import React from "react";
import { render, screen, fireEvent } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FullPageChatLayout } from "./FullPageChatLayout";

jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: () => null,
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: any) => any) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  Object.defineProperty(URL, "createObjectURL", {
    configurable: true,
    value: jest.fn(() => "blob:test-url"),
  });
  Object.defineProperty(URL, "revokeObjectURL", {
    configurable: true,
    value: jest.fn(),
  });
});

const renderLayout = (
  overrides: Partial<React.ComponentProps<typeof FullPageChatLayout>> = {},
) =>
  render(
    <FullPageChatLayout
      messages={[]}
      onSendMessage={jest.fn()}
      isLoading={false}
      conversations={[]}
      onLoadConversation={jest.fn()}
      onNewConversation={jest.fn()}
      onSearchConversations={jest.fn()}
      onLoadMoreConversations={jest.fn()}
      conversationsLoading={false}
      currentConversationId={null}
      welcomeTitle="Welcome to WS"
      welcomeDescription="Start a new conversation"
      {...overrides}
    />,
  );

describe("FullPageChatLayout load-failed surface", () => {
  it("renders the load-failed surface instead of the welcome content when history load failed", () => {
    renderLayout({ historyLoadFailed: true });

    expect(screen.queryByText("Welcome to WS")).not.toBeInTheDocument();
    expect(
      screen.getByTestId("conversation-load-failed"),
    ).toBeInTheDocument();
  });

  it("renders the welcome content when there is no load failure", () => {
    renderLayout({ historyLoadFailed: false });

    expect(screen.getByText("Welcome to WS")).toBeInTheDocument();
    expect(
      screen.queryByTestId("conversation-load-failed"),
    ).not.toBeInTheDocument();
  });

  it("renders a loading indicator instead of the load-failed surface while a newly selected conversation is loading, even when a prior conversation's failure is still flagged", () => {
    renderLayout({ historyLoadFailed: true, historyLoading: true });

    expect(screen.getByTestId("conversation-history-loading")).toBeInTheDocument();
    expect(
      screen.queryByTestId("conversation-load-failed"),
    ).not.toBeInTheDocument();
    expect(screen.queryByText("Welcome to WS")).not.toBeInTheDocument();
  });

  it("renders a loading indicator instead of the welcome content while history is loading", () => {
    renderLayout({ historyLoadFailed: false, historyLoading: true });

    expect(screen.getByTestId("conversation-history-loading")).toBeInTheDocument();
    expect(screen.queryByText("Welcome to WS")).not.toBeInTheDocument();
  });

  it("offers a retry affordance on the load-failed surface and invokes onRetryHistoryLoad when clicked", () => {
    const onRetryHistoryLoad = jest.fn();
    renderLayout({ historyLoadFailed: true, onRetryHistoryLoad });

    const retryButton = screen.getByRole("button", { name: /retry/i });
    fireEvent.click(retryButton);

    expect(onRetryHistoryLoad).toHaveBeenCalledTimes(1);
  });
});
